import { motion } from "framer-motion";
import WhatsAppIcon from "@/components/site/WhatsAppIcon";

// Monta o link wa.me a partir do número salvo em Conteúdo do site
export const waChat = (raw, text = "") => {
  const d = String(raw || "").replace(/\D/g, "");
  if (!d) return null;
  const num = d.startsWith("55") ? d : `55${d}`;
  return `https://wa.me/${num}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

const DEFAULT_MSG = "Olá, Tacilaine! Vim pelo seu site e gostaria de conversar sobre terapia.";

export const waMsg = (content) => (content?.whatsapp_msg || "").trim() || DEFAULT_MSG;

export default function WhatsAppFloat({ content }) {
  const url = waChat(content?.whatsapp, waMsg(content));
  if (!url) return null;
  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Conversar no WhatsApp"
      title="Conversar no WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      className="group fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-[transform,box-shadow] duration-300 hover:scale-110 hover:shadow-[0_14px_36px_rgba(37,211,102,0.55)]"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping [animation-duration:2.4s]" aria-hidden="true" />
      <WhatsAppIcon className="relative w-6 h-6" />
    </motion.a>
  );
}
